module.exports = __webpack_public_path__ + "static/media/icon-google-red.f923ce06.svg";